import { jsxs, jsx } from 'react/jsx-runtime';
import { SliderInput, SliderTrack, SliderRange, SliderHandle } from '@reach/slider';
import clsx from 'clsx';
import css from './Slider.module.css.js';

function Slider({
  value,
  min = 0,
  max = 1,
  step,
  onChange,
  variant = 'default',
  markers,
  BelowHandleElement,
  AboveHandleElement,
  handleClassName,
  ...rest
}) {
  return jsxs("div", {
    className: clsx('contents', css.sliderContainer, css[variant]),
    children: [AboveHandleElement && jsx("div", {
      draggable: false,
      tabIndex: -1,
      className: "pointer-events-none select-none pt-xs opacity-0 outline-none",
      children: AboveHandleElement
    }), jsx(SliderInput, {
      min: min,
      max: max,
      step: step,
      value: value,
      onChange: onChange,
      ...rest,
      children: jsxs(SliderTrack, {
        children: [markers?.map(({
          value,
          marker
        }) => {
          return jsx("div", {
            className: "absolute",
            style: {
              top: '50%',
              left: `${100 * (value - min) / (max - min)}%`,
              transform: 'translate(-50%, -50%)'
            },
            children: marker
          }, value);
        }), jsx(SliderRange, {}), jsx(SliderHandle, {
          className: clsx('cursor-pointer outline-none', handleClassName),
          children: jsxs("div", {
            className: "pointer-events-none flex h-full w-full select-none items-center justify-center outline-none",
            children: [AboveHandleElement && jsx("div", {
              draggable: false,
              tabIndex: -1,
              className: "pointer-events-none absolute -top-lg select-none outline-none",
              children: AboveHandleElement
            }), jsx("div", {
              className: clsx('mr-2xs rounded-small bg-white', css.thumbStripes)
            }), jsx("div", {
              className: clsx('rounded-small bg-white', css.thumbStripes)
            }), BelowHandleElement && jsx("div", {
              draggable: false,
              tabIndex: -1,
              className: "pointer-events-none absolute -bottom-lg select-none outline-none",
              children: BelowHandleElement
            })]
          })
        })]
      })
    }), BelowHandleElement && jsx("div", {
      draggable: false,
      tabIndex: -1,
      className: "pointer-events-none select-none pt-xs opacity-0 outline-none",
      children: BelowHandleElement
    })]
  });
}

export { Slider };
